import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL } from 'config/env.config'

const FETCH_STATISTICS_API_ID = 'EMPLOYEE_PROGRAMS_STATISTICS_API'

const apiCall = enhancedMakeFetchAction(FETCH_STATISTICS_API_ID, ({ id }) => ({
  endpoint: `${API_BASE_URL}/investcore-api/flex/v1/employees/${id}/programs/statistics`,
  method: 'GET'
}))

export default apiCall
